import { render, staticRenderFns } from "./promotional.vue?vue&type=template&id=63322d3d&scoped=true&"
import script from "./promotional.vue?vue&type=script&lang=js&"
export * from "./promotional.vue?vue&type=script&lang=js&"
import style0 from "./promotional.vue?vue&type=style&index=0&id=63322d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63322d3d",
  null
  
)

export default component.exports